import Swiper from 'swiper';
import { Pagination, Autoplay, A11y } from 'swiper/modules';
import '../../ts/sidenav-content';
import '../../ts/scroll-position-detect';
import '../../ts/scroll-offset';

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

new Swiper('.header-hero-swiper', {
    modules: [Pagination, Autoplay, A11y],
    loop: true,
    autoplay: reduceMotion ? false : {
        delay: 5000,
        disableOnInteraction: false,
    },
    a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
    },
    pagination: {
        el: '.header-hero-pagination',
        clickable: true,
    },
});
